import React from "react";

/**
 * Standard section header used across dashboards & content pages.
 *
 * Visual signature:
 *   ┌─ optional top horizontal divider (gray-300, 2px)
 *   │  ┃ (vertical accent bar 4px)  EYEBROW
 *   │                              Title
 *   └─ optional right-side slot for actions (e.g. CTA button)
 *
 * Props
 *   eyebrow   string  small uppercase label above the title
 *   title     string  main heading
 *   divider   bool    show top horizontal divider + spacer (default true)
 *   actions   node    optional right-aligned action slot
 *   accent    string  hex color for the vertical bar + eyebrow tint (default Canales blue)
 *   className string  extra classes for the outer wrapper
 *   testid    string  data-testid for tests
 */
export default function SectionHeader({
  eyebrow,
  title,
  divider = true,
  actions = null,
  accent = "#1B2E7A",
  className = "",
  testid,
}) {
  const wrap = `${divider ? "pt-12 border-t-2 border-[#D1D5DB] " : ""}mb-6 flex items-end justify-between gap-4 flex-wrap ${className}`;
  return (
    <div className={wrap} data-testid={testid}>
      <div className="pl-4 border-l-4" style={{ borderColor: accent }}>
        {eyebrow ? (
          <p
            className="text-xs uppercase tracking-[0.2em] mb-1 font-medium"
            style={{ color: accent }}
          >
            {eyebrow}
          </p>
        ) : null}
        <h2 className="font-heading text-2xl text-[#1A1A1A] leading-tight">{title}</h2>
      </div>
      {actions ? <div className="flex items-center gap-2 flex-wrap">{actions}</div> : null}
    </div>
  );
}
